// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import Automatic from './Automatic'
import Controlled from './Controlled'

// Constants
export { POPOVER_Z_INDEX } from './constants'

const Popover = ({ method, ...otherProps }) => {
  let props = otherProps

  if (window.testMode) {
    props = { ...props, animation: 'none', delay: 0 }
  }

  if (method === 'manual') {
    return <Controlled {...props} />
  }

  return <Automatic method={method} {...props} />
}

Popover.propTypes = {
  method: PropTypes.string
}

export default Popover
